/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Category, IGamesRequest } from "./interfaces/intefaces";
import {
    GamesEndpointUrl,
    CategoriesEndpointUrl,
    ProvidersEndpointUrl,
    perPage,
    UserFavoritesEndpointUrl,
    GameWeekEndpointUrl,
} from "./config/consts";
import "@styles/slick.css";
import "@styles/slick-theme.css";
import "@styles/app.scss";

import { useTranslation } from "./hooks/hooks";
import { BottomNavigation, BottomNavigationAction, Box, Drawer, Paper } from "@mui/material";
import Sidebar from "./components/Sidebar";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useAtom } from "jotai";
import {
    activeCategoryAtom,
    activeProvidersAtom,
    categoriesAtom,
    categoryTypeAtom,
    currentPageAtom,
    gameofWeekAtom,
    gamesHotAtom,
    gamesLobbyAtom,
    gamesNewAtom,
    gamesUserFavoritesAtom,
    gridSizeAtom,
    providersAtom,
    userIsLoggedInAtom,
} from "./state/games";
import Icon from "./components/Icon";
import { ArrowLeftIcon, ArrowRightIcon } from "./components/Icons";
import ProvidersModal from "./components/ProvidersModal";
import { noop } from "lodash";
import _ from "lodash";
import MobileMenu from "./components/MobileMenu";
import { routes } from "./router/Routes";
import { isExternalPage } from "./helpers/helpers";

declare const config: any;
function App() {
    const { route: init_route } = config;
    const { _e } = useTranslation();
    const [userIsLoggedIn, setUserIsLoggedIn] = useAtom(userIsLoggedInAtom);
    const [gridSize] = useAtom(gridSizeAtom);
    const [categories, setCategories] = useAtom(categoriesAtom);
    const [activeCategory, setActiveCategory] = useAtom(activeCategoryAtom);
    const [, setCategoryType] = useAtom(categoryTypeAtom);
    const [, setProviders] = useAtom(providersAtom);
    const [activeProvider, setActiveProvider] = useAtom(activeProvidersAtom);
    const [, setGamesHot] = useAtom(gamesHotAtom);
    const [, setGamesNew] = useAtom(gamesNewAtom);
    const [, setGamesLobby] = useAtom(gamesLobbyAtom);
    const [, setGameofWeek] = useAtom(gameofWeekAtom);
    const [, setGamesUserFavorites] = useAtom(gamesUserFavoritesAtom);
    const [, setCurrentPage] = useAtom(currentPageAtom);
    const [categoryType] = useAtom(categoryTypeAtom);
    const location = useLocation();

    const [error, setError] = useState({ message: null });
    const [viewportSize, setViewportSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    const [drawerOpen, setDrawerOpen] = useState(
        viewportSize.width < 1200 || isExternalPage(location.pathname) ? false : true,
    );
    const [drawerWidth, setDrawerWidth] = useState(
        viewportSize.width < 1200 || isExternalPage(location.pathname) ? 40 : 240,
    );
    const [isMobile] = useState(viewportSize.width < 992);
    const navigate = useNavigate();

    const params: IGamesRequest = {
        category_id: activeCategory,
        categoryType: categoryType,
        mobile: 1,
        forfun: undefined,
        lang: undefined,
        ct: 0,
        ps: perPage,
        prs: activeProvider,
    };
    const toggleDrawer = () => {
        setDrawerWidth(prevWidth => (prevWidth === 40 ? 240 : 40));
        setDrawerOpen(!drawerOpen);

        document.body.classList.toggle("drawer-open");
    };

    const categoryHandler = (category_id: number) => {
        if (category_id === 0) {
            setActiveCategory(0);
            setActiveProvider([]);
        } else {
            setActiveCategory(category_id);
        }
    };

    const receiveMessage = (e: any) => {
        if (typeof e.data === "string" && e.data.includes("UserState")) {
            const userUsername = JSON.parse(e.data).data.userUsername;
            if (userUsername !== null) {
                setUserIsLoggedIn(true);
            } else {
                setUserIsLoggedIn(false);
            }
        }
    };
    const initCategories = (categories: Category[]) => {
        const activeCategory = categories?.filter(category => {
            const f = location.pathname.match(/.*\/(.*)/);
            return f && f.length > 1 && category.slug === f[1];
        });
        if (activeCategory.length) {
            setActiveCategory(activeCategory[0].id);
            setCategoryType(activeCategory[0].type);
        }
        activeCategory?.length && setActiveCategory(activeCategory[0].id);
        setCategories(categories);
    };

    useEffect(() => {
        init_route && navigate(init_route);

        const handleResize = () => {
            setViewportSize({ width: window.innerWidth, height: window.innerHeight });
        };

        window.addEventListener("resize", handleResize);
        !(viewportSize.width < 1200 || isExternalPage(location.pathname))
            ? document.body.classList.add("drawer-open")
            : noop;

        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    useEffect(() => {
        const fetchCategories = async (callback: any, errorCallback: any) => {
            const url = CategoriesEndpointUrl;
            const returnedData = await axios
                .get(url, { params: { categoryType: params.categoryType } })
                .then(res => res.data.data)
                .catch(error => errorCallback(error.toJSON()));
            callback(returnedData);
        };
        fetchCategories(initCategories, setError);

        const fetchProviders = async (callback: any, errorCallback: any) => {
            const url = ProvidersEndpointUrl;
            const returnedData = await axios
                .get(url, {
                    params: { categoryType: params.categoryType },
                })
                .then(res => res.data.data)
                .catch(error => errorCallback(error.toJSON()));
            callback(returnedData);
        };
        fetchProviders(setProviders, setError);

        window.addEventListener("message", receiveMessage, false);
    }, []);
    useEffect(() => {
        setCurrentPage(0);
    }, [activeCategory]);

    useEffect(() => {
        const fetchGamesHot = async (callback: any, errorCallback: any) => {
            const url = GamesEndpointUrl;
            const returnedData = await axios
                .get(url, {
                    params: { new: 0, hot: 1, mobile: 1, categoryType: params.categoryType },
                })
                .then(res => res.data.data)
                .catch(error => errorCallback(error.toJSON()));
            callback(returnedData);
        };
        fetchGamesHot(setGamesHot, setError);

        const fetchGameWeek = async (callback: any, errorCallback: any) => {
            const url = GameWeekEndpointUrl;
            const returnedData = await axios
                .get(url)
                .then(res => res.data.data.games[0])
                .catch(error => errorCallback(error.toJSON()));
            callback(returnedData);
        };
        fetchGameWeek(setGameofWeek, setError);

        const fetchGamesNew = async (callback: any, errorCallback: any) => {
            const url = GamesEndpointUrl;
            const returnedData = await axios
                .get(url, {
                    params: { new: 1, hot: 0, mobile: 1, categoryType: params.categoryType },
                })
                .then(res => res.data.data)
                .catch(error => errorCallback(error.toJSON()));
            callback(returnedData);
        };
        fetchGamesNew(setGamesNew, setError);

        const fetchGamesLobby = async (callback: any, errorCallback: any) => {
            const url = GamesEndpointUrl;
            const returnedData = await axios
                .get(url, {
                    params: {
                        ps: 12,
                        mobile: 1,
                        hot: 0,
                        new: 0,
                        categoryType: params.categoryType,
                    },
                })
                .then(res => res.data.data)
                .catch(error => errorCallback(error.toJSON()));
            callback(returnedData);
        };
        fetchGamesLobby(setGamesLobby, setError);
    }, []);

    useEffect(() => {
        const fetchGamesUserFavorites = async (callback: any, errorCallback: any) => {
            const url = UserFavoritesEndpointUrl;
            const returnedData = await axios
                .get(url, { withCredentials: true })
                .then(res => (res.status === 200 ? res.data.data : []))
                .catch(error => errorCallback(error.toJSON()));
            callback({ type: "init", payload: returnedData });
        };

        userIsLoggedIn && fetchGamesUserFavorites(setGamesUserFavorites, setError);
    }, [userIsLoggedIn]);

    return (
        <>
            {error.message !== null && <div>{error.message}</div>}
            <div className="container-fw">
                <div className={`games-panel ${gridSize}`}>
                    <Drawer
                        variant="persistent"
                        anchor="left"
                        open={true}
                        className={drawerWidth === 40 ? "collapsed" : ""}
                        sx={{
                            width: drawerWidth,
                            flexShrink: 0,
                            "& .MuiDrawer-paper": {
                                width: drawerWidth,
                                paddingTop: "30px",
                                border: 0,
                                boxSizing: "border-box",
                                backgroundColor: "#0f1432",
                            },
                            "@media (max-width:991px)": {
                                display: "none",
                            },
                        }}
                    >
                        <Sidebar
                            activeCategory={activeCategory}
                            categories={categories}
                            setCategoryType={setCategoryType}
                            updateCategory={categoryHandler}
                        />
                    </Drawer>
                    <Box
                        className="casino-content"
                        sx={{
                            width: isMobile ? "100%" : `calc(100% - ${drawerWidth}px )`,
                            position: "relative",
                        }}
                    >
                        <Outlet />
                        <ProvidersModal />
                    </Box>
                    <Box
                        className="drawerToggle"
                        sx={{
                            left: `${drawerWidth}px`,
                            "@media (max-width:991px)": {
                                display: "none",
                            },
                        }}
                        onClick={toggleDrawer}
                    >
                        {drawerOpen ? (
                            <Icon icon={ArrowLeftIcon} />
                        ) : (
                            <Icon icon={ArrowRightIcon} />
                        )}
                    </Box>
                </div>

                <MobileMenu
                    activeCategory={activeCategory}
                    categories={categories}
                    updateCategory={categoryHandler}
                />
            </div>
        </>
    );
}

export default App;
